import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import "./Privacy.css";
import "react-awesome-slider/dist/styles.css";
// Main component for Privacy and Policy page

export default class PrivacyComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Container className="SignUpasContainerLightGray privacy-policy-container ">
          <Grid container justifyContent="center">
            <Grid item md={10}>
              <h2 className="container-title">Privacy Policy</h2>

              <div className="terms-subcontainer">
                <p className="policy-meta">
                  <b>Effective Date:</b> 5 October 2026
                  <br />
                  <b>Last Updated:</b> 1 October 2026
                </p>
                <p>
                  GBR Farming Private Limited (“GBR Farming”, “we”, “us”, or
                  “our”) respects your privacy and is committed to protecting
                  the personal information and data entrusted to us.
                </p>
                <p>
                  This Privacy Policy explains how GBR Farming collects,
                  receives, uses, stores, processes, discloses and protects
                  personal information when you access or use our website,
                  digital services, ecosystem infrastructure, ecosystem
                  applications, platform interfaces, or otherwise interact with
                  us.
                </p>
                <p>
                  This Privacy Policy should be read together with our Terms
                  &amp; Conditions and any other applicable contractual terms
                  governing specific GBR Farming products, services, ecosystem
                  networks or commercial relationships.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>1. About GBR Farming</h3>
                <p>
                  GBR Farming Private Limited is an Indian private limited
                  company incorporated under the Companies Act, 2013.
                </p>
                <p>
                  <b>Corporate Identity Number (CIN):</b> U74999KA2021PTC143080
                </p>
                <p>
                  <b>Registered Office:</b>
                  <br />
                  49054, SDA,
                  <br />
                  Panthur Main Road, Balagere,
                  <br />
                  Bangalore – 560087, Karnataka, India.
                </p>
                <p>
                  <b>Website:</b> gbrapp.com
                </p>
                <p>
                  GBR Farming operates as an ecosystem infrastructure and
                  technology provider. Our services may support organisations
                  that build, operate and govern ecosystem networks, including
                  ecosystem network operators (“ENOs”), network participants and
                  other authorised users.
                </p>
                <p>
                  Depending on the service and relationship involved, GBR
                  Farming may process personal information:
                </p>
                <ul>
                  <li>
                    directly for its own business and service purposes; or
                  </li>
                  <li>
                    on behalf of an ENO, customer or other organisation that
                    uses GBR Farming infrastructure and services.
                  </li>
                </ul>
                <p>
                  The applicable role and responsibilities of GBR Farming and
                  the relevant customer or ENO may therefore depend on the
                  particular service, contractual arrangement and applicable
                  law.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>2. Scope of This Privacy Policy</h3>
                <p>
                  This Privacy Policy applies to personal information processed
                  in connection with:
                </p>
                <ul>
                  <li>the GBR Farming website;</li>
                  <li>enquiries and communications with GBR Farming;</li>
                  <li>requests for demonstrations or information;</li>
                  <li>account registration and onboarding;</li>
                  <li>GBR Farming digital services and applications;</li>
                  <li>ecosystem infrastructure and platform services;</li>
                  <li>ecosystem network participation;</li>
                  <li>customer and ENO interactions;</li>
                  <li>support and service communications; and</li>
                  <li>
                    other services or digital interfaces that expressly
                    reference this Privacy Policy.
                  </li>
                </ul>
                <p>
                  Specific GBR Farming services may have additional privacy
                  notices or contractual provisions. Where such provisions
                  apply, they will supplement this Privacy Policy.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>3. Information We Collect</h3>
                <p>
                  We collect only information that is reasonably necessary for
                  the purposes for which it is processed, subject to applicable
                  law.
                </p>

                <h4>3.1 Information You Provide to Us</h4>
                <p>
                  Depending on how you interact with GBR Farming, we may
                  collect:
                </p>
                <ul>
                  <li>name;</li>
                  <li>email address;</li>
                  <li>telephone or mobile number;</li>
                  <li>organisation/company name;</li>
                  <li>designation or professional role;</li>
                  <li>organisation type;</li>
                  <li>ecosystem role or user type;</li>
                  <li>business contact information;</li>
                  <li>location or operating area where provided;</li>
                  <li>information submitted through enquiry or demo forms;</li>
                  <li>account and registration information;</li>
                  <li>information provided during onboarding;</li>
                  <li>information included in communications with us;</li>
                  <li>support and service-related information; and</li>
                  <li>any other information you voluntarily provide.</li>
                </ul>

                <h4>3.2 Account and Platform Information</h4>
                <p>
                  Where you use GBR Farming digital services, we may collect
                  information associated with your account, organisation or
                  authorised access, including:
                </p>
                <ul>
                  <li>user account information;</li>
                  <li>organisation profile;</li>
                  <li>ecosystem network association;</li>
                  <li>access permissions;</li>
                  <li>site and solution access information;</li>
                  <li>role and permission configurations;</li>
                  <li>service configuration information;</li>
                  <li>authentication-related information;</li>
                  <li>platform activity and usage information; and</li>
                  <li>records necessary to administer and secure the service.</li>
                </ul>

                <h4>3.3 Ecosystem and Operational Information</h4>
                <p>
                  Depending on the ecosystem, service and permissions involved,
                  GBR Farming infrastructure may process information relating
                  to:
                </p>
                <ul>
                  <li>sites and locations;</li>
                  <li>assets and equipment;</li>
                  <li>ecosystem participants;</li>
                  <li>business operations;</li>
                  <li>field or operational activities;</li>
                  <li>transactions or commercial activities;</li>
                  <li>supply-chain activities;</li>
                  <li>network activities;</li>
                  <li>service delivery;</li>
                  <li>ecosystem performance; and</li>
                  <li>
                    other information submitted or generated through an
                    ecosystem application.
                  </li>
                </ul>
                <p>
                  Such information may include personal information where it
                  relates to an identifiable individual.
                </p>

                <h4>3.4 Technical and Usage Information</h4>
                <p>
                  When you access our website or digital services, certain
                  technical information may be collected automatically,
                  including:
                </p>
                <ul>
                  <li>Internet Protocol (IP) address;</li>
                  <li>browser type and version;</li>
                  <li>operating system;</li>
                  <li>device information;</li>
                  <li>device or application identifiers where applicable;</li>
                  <li>date and time of access;</li>
                  <li>pages or services accessed;</li>
                  <li>referring or exit pages;</li>
                  <li>session information;</li>
                  <li>diagnostic information;</li>
                  <li>security and authentication logs; and</li>
                  <li>information relating to system performance and usage.</li>
                </ul>

                <h4>3.5 Communications</h4>
                <p>
                  We may retain information contained in communications you
                  send to us, including:
                </p>
                <ul>
                  <li>enquiries;</li>
                  <li>requests for demonstrations;</li>
                  <li>support requests;</li>
                  <li>feedback;</li>
                  <li>complaints;</li>
                  <li>legal or privacy requests; and</li>
                  <li>other correspondence.</li>
                </ul>
              </div>

              <div className="terms-subcontainer">
                <h3>4. Information Collected Through Cookies and Similar Technologies</h3>
                <p>
                  Our website and digital services may use cookies, local
                  storage, pixels, tags, logs and similar technologies.
                </p>
                <p>
                  These technologies may be used for purposes including:
                </p>
                <ul>
                  <li>enabling essential website functionality;</li>
                  <li>maintaining sessions;</li>
                  <li>remembering preferences;</li>
                  <li>understanding website usage;</li>
                  <li>measuring service performance;</li>
                  <li>improving user experience;</li>
                  <li>maintaining security; and</li>
                  <li>supporting analytics and other functionality.</li>
                </ul>
                <p>
                  Where required by applicable law, we will obtain appropriate
                  consent before using non-essential cookies or similar
                  technologies.
                </p>
                <p>
                  You may be able to manage cookies through your browser or
                  other available privacy controls. Disabling certain cookies
                  may affect the functionality of some website or service
                  features.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>5. How We Use Personal Information</h3>
                <p>
                  We may process personal information for the following
                  purposes, as applicable:
                </p>

                <h4>5.1 Providing Services</h4>
                <p>To:</p>
                <ul>
                  <li>provide and operate GBR Farming services;</li>
                  <li>create and administer accounts;</li>
                  <li>onboard organisations and users;</li>
                  <li>provide ecosystem infrastructure;</li>
                  <li>operate digital services and applications;</li>
                  <li>enable authorised ecosystem participation;</li>
                  <li>provide customer and technical support; and</li>
                  <li>
                    perform services requested by you or your organisation.
                  </li>
                </ul>

                <h4>5.2 Business Operations</h4>
                <p>To:</p>
                <ul>
                  <li>manage our business relationships;</li>
                  <li>communicate with customers and users;</li>
                  <li>process service-related requests;</li>
                  <li>maintain business records;</li>
                  <li>manage contracts and commercial relationships;</li>
                  <li>administer billing and payments where applicable; and</li>
                  <li>manage internal operations.</li>
                </ul>

                <h4>5.3 Security and Protection</h4>
                <p>To:</p>
                <ul>
                  <li>authenticate users;</li>
                  <li>control access;</li>
                  <li>protect systems and information;</li>
                  <li>detect and prevent unauthorised activity;</li>
                  <li>investigate suspected misuse;</li>
                  <li>monitor security events;</li>
                  <li>maintain service integrity; and</li>
                  <li>
                    protect GBR Farming, customers, users and other persons
                    from fraud, abuse or security threats.
                  </li>
                </ul>

                <h4>5.4 Improvement and Development</h4>
                <p>We may use information to:</p>
                <ul>
                  <li>understand how our services are used;</li>
                  <li>improve products and services;</li>
                  <li>develop new capabilities;</li>
                  <li>analyse service performance;</li>
                  <li>troubleshoot technical issues;</li>
                  <li>improve usability; and</li>
                  <li>develop ecosystem infrastructure and technology.</li>
                </ul>
                <p>
                  Where appropriate, information may be aggregated,
                  de-identified or otherwise processed so that it is not
                  reasonably identifiable to an individual.
                </p>

                <h4>5.5 Communications and Marketing</h4>
                <p>
                  Subject to applicable law and your preferences, we may use
                  contact information to communicate with you about:
                </p>
                <ul>
                  <li>services;</li>
                  <li>product updates;</li>
                  <li>ecosystem initiatives;</li>
                  <li>events;</li>
                  <li>relevant business information; and</li>
                  <li>
                    other communications that may be of interest to you.
                  </li>
                </ul>
                <p>
                  You may opt out of promotional communications at any time. We
                  may continue to send essential service, security, legal or
                  transactional communications where necessary.
                </p>

                <h4>5.6 Legal and Regulatory Requirements</h4>
                <p>
                  We may process and disclose information where reasonably
                  necessary to:
                </p>
                <ul>
                  <li>comply with applicable law;</li>
                  <li>comply with lawful orders or requests;</li>
                  <li>establish, exercise or defend legal rights;</li>
                  <li>prevent or investigate unlawful activity;</li>
                  <li>
                    protect the rights, property or safety of GBR Farming or
                    others; or
                  </li>
                  <li>comply with applicable regulatory requirements.</li>
                </ul>
              </div>

              <div className="terms-subcontainer">
                <h3>6. Legal Basis for Processing</h3>
                <p>
                  Depending on the circumstances and applicable law, GBR
                  Farming may process personal information based on:
                </p>
                <ul>
                  <li>your consent;</li>
                  <li>performance or initiation of a contract;</li>
                  <li>compliance with a legal obligation;</li>
                  <li>
                    a legally permitted legitimate or reasonable purpose;
                  </li>
                  <li>
                    prevention or investigation of fraud, misuse or security
                    incidents;
                  </li>
                  <li>protection of rights and interests;</li>
                  <li>other permitted grounds under applicable law; or</li>
                  <li>
                    another lawful basis available under the law applicable to
                    the relevant processing activity.
                  </li>
                </ul>
                <p>
                  Where consent is required, GBR Farming will seek consent in
                  an appropriate manner and, where applicable, provide a
                  reasonably accessible mechanism for withdrawal.
                </p>
                <p>
                  India's Digital Personal Data Protection Act, 2023 and the
                  Digital Personal Data Protection Rules, 2025 establish a
                  statutory framework for digital personal data processing,
                  with provisions coming into force on a staggered basis. GBR
                  Farming will comply with provisions applicable to it as and
                  when they become effective.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>7. Ecosystem Data and Customer Data</h3>
                <p>
                  GBR Farming's ecosystem infrastructure may be used by
                  organisations, including ENOs, to operate their own ecosystem
                  networks.
                </p>
                <p>
                  In such circumstances, an ENO or customer may determine:
                </p>
                <ul>
                  <li>
                    what information it collects from its users or
                    participants;
                  </li>
                  <li>
                    the purposes for which that information is collected;
                  </li>
                  <li>how that information is used within its ecosystem;</li>
                  <li>who may access that information; and</li>
                  <li>how its ecosystem operates.</li>
                </ul>
                <p>
                  Where GBR Farming processes personal information on behalf of
                  an ENO or customer, GBR Farming will process that information
                  in accordance with applicable contractual arrangements and
                  lawful instructions, subject to applicable law.
                </p>
                <p>
                  The relevant ENO or customer may therefore have its own
                  privacy notice, terms or data-processing requirements
                  applicable to information it collects directly from its users
                  or participants.
                </p>
                <p>
                  Users should review the privacy information provided by the
                  relevant ENO or ecosystem operator where they participate in
                  an ecosystem operated by another organisation.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>8. Information We Share</h3>
                <p>
                  GBR Farming does not sell personal information as a business
                  model.
                </p>
                <p>
                  We may disclose or provide access to personal information
                  where reasonably necessary for the purposes described in this
                  Privacy Policy.
                </p>
                <p>This may include sharing information with:</p>

                <h4>8.1 Customers and Ecosystem Operators</h4>
                <p>
                  Where necessary to provide an ecosystem service, information
                  may be made available to an authorised customer, ENO or
                  organisation responsible for the relevant ecosystem.
                </p>
                <p>
                  Access will depend on the applicable service, permissions,
                  contractual arrangements and lawful purpose.
                </p>

                <h4>8.2 Service Providers and Technology Partners</h4>
                <p>
                  We may engage third-party service providers to support:
                </p>
                <ul>
                  <li>cloud infrastructure;</li>
                  <li>hosting;</li>
                  <li>communications;</li>
                  <li>authentication;</li>
                  <li>analytics;</li>
                  <li>security;</li>
                  <li>software and technology services;</li>
                  <li>customer support;</li>
                  <li>payment processing; and</li>
                  <li>other business operations.</li>
                </ul>
                <p>
                  Such providers may process information on our behalf or as
                  otherwise permitted by applicable law and contractual
                  arrangements.
                </p>

                <h4>8.3 Professional Advisors</h4>
                <p>
                  We may disclose information to professional advisors such as
                  legal, accounting, auditing, consulting or other professional
                  service providers where reasonably necessary.
                </p>

                <h4>8.4 Legal and Regulatory Authorities</h4>
                <p>
                  We may disclose information to government authorities,
                  regulators, courts, law-enforcement agencies or other
                  authorised bodies where required or permitted by law.
                </p>

                <h4>8.5 Business Transactions</h4>
                <p>
                  If GBR Farming is involved in a merger, acquisition,
                  restructuring, financing, sale of assets, investment,
                  reorganisation or similar corporate transaction, information
                  may be transferred or disclosed as reasonably necessary for
                  that transaction, subject to applicable law.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>9. Data Processed on Behalf of Customers</h3>
                <p>
                  Where GBR Farming provides infrastructure or services to an
                  ENO or other customer and processes personal information on
                  that customer's behalf:
                </p>
                <ul>
                  <li>
                    the customer may determine the purposes and means of
                    relevant processing;
                  </li>
                  <li>
                    GBR Farming may process information according to the
                    customer's lawful instructions and contractual
                    requirements;
                  </li>
                  <li>
                    GBR Farming will apply appropriate confidentiality and
                    security measures;
                  </li>
                  <li>
                    access will be limited to authorised personnel and service
                    providers as appropriate;
                  </li>
                  <li>
                    GBR Farming will provide reasonable assistance relating to
                    applicable privacy obligations where required under the
                    relevant agreement and applicable law; and
                  </li>
                  <li>
                    information will be returned, deleted or retained in
                    accordance with the applicable contract, lawful
                    requirements and legitimate business or legal retention
                    requirements.
                  </li>
                </ul>
                <p>
                  The specific allocation of data-protection responsibilities
                  may be further defined in the applicable customer or ENO
                  agreement.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>10. Data Security</h3>
                <p>
                  GBR Farming takes reasonable technical, organisational and
                  administrative measures designed to protect personal
                  information against:
                </p>
                <ul>
                  <li>unauthorised access;</li>
                  <li>unauthorised disclosure;</li>
                  <li>alteration;</li>
                  <li>loss;</li>
                  <li>destruction;</li>
                  <li>misuse; and</li>
                  <li>other unlawful or unauthorised processing.</li>
                </ul>
                <p>
                  Depending on the nature of the information and service,
                  safeguards may include:
                </p>
                <ul>
                  <li>access controls;</li>
                  <li>authentication mechanisms;</li>
                  <li>role-based permissions;</li>
                  <li>encryption where appropriate;</li>
                  <li>secure infrastructure;</li>
                  <li>logging and monitoring;</li>
                  <li>backup and recovery controls;</li>
                  <li>security testing and maintenance;</li>
                  <li>confidentiality obligations; and</li>
                  <li>incident response procedures.</li>
                </ul>
                <p>
                  No method of transmission or storage can be guaranteed to be
                  completely secure. Accordingly, while GBR Farming takes
                  reasonable measures to protect information, absolute security
                  cannot be guaranteed.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>11. Data Retention</h3>
                <p>
                  GBR Farming retains personal information only for as long as
                  reasonably necessary for the purposes for which it was
                  collected or processed, unless a longer period is required or
                  permitted by applicable law.
                </p>
                <p>Retention periods may depend on:</p>
                <ul>
                  <li>the nature of the information;</li>
                  <li>the purpose of processing;</li>
                  <li>the duration of the customer or user relationship;</li>
                  <li>contractual requirements;</li>
                  <li>legal and regulatory requirements;</li>
                  <li>dispute resolution;</li>
                  <li>security and fraud-prevention requirements; and</li>
                  <li>legitimate business requirements.</li>
                </ul>
                <p>
                  When personal information is no longer required, GBR Farming
                  may securely delete, anonymise or otherwise dispose of it in
                  accordance with applicable law and its retention practices.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>12. International Data Transfers</h3>
                <p>
                  GBR Farming may use technology, cloud infrastructure or
                  service providers that operate in jurisdictions outside the
                  location where information was originally collected.
                </p>
                <p>
                  Where personal information is transferred, stored or
                  processed across jurisdictions, GBR Farming will take
                  measures required by applicable law and applicable
                  contractual arrangements.
                </p>
                <p>
                  Where legally required, appropriate safeguards, permissions
                  or other mechanisms will be used for such transfers.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>13. Your Privacy Rights</h3>
                <p>
                  Subject to applicable law, individuals may have rights
                  concerning their personal information, including rights to:
                </p>
                <ul>
                  <li>request access to personal information;</li>
                  <li>
                    request correction or updating of inaccurate information;
                  </li>
                  <li>request deletion where legally available;</li>
                  <li>
                    withdraw consent where processing is based on consent;
                  </li>
                  <li>request information regarding processing;</li>
                  <li>raise a grievance or complaint;</li>
                  <li>
                    exercise other rights available under applicable
                    data-protection law.
                  </li>
                </ul>
                <p>
                  The availability and scope of these rights may depend on the
                  applicable law, the nature of the processing and GBR
                  Farming's role in relation to the information.
                </p>
                <p>
                  To exercise a privacy right or submit a privacy request,
                  contact us using the details in Section 20.
                </p>
                <p>
                  Where GBR Farming processes information on behalf of an ENO
                  or customer, you may also need to submit your request to the
                  relevant ENO or customer, particularly where that
                  organisation determines the purpose and means of processing.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>14. Accuracy of Information</h3>
                <p>
                  We rely on information provided by users, customers and
                  ecosystem participants being accurate and current.
                </p>
                <p>
                  You should provide accurate information and notify the
                  relevant organisation or GBR Farming where information needs
                  to be corrected or updated.
                </p>
                <p>
                  GBR Farming may take reasonable steps to verify information
                  where necessary for security, service delivery or legal
                  compliance.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>15. Third-Party Websites and Services</h3>
                <p>
                  Our website or services may contain links to websites,
                  applications or services operated by third parties.
                </p>
                <p>
                  These third-party services may have their own privacy
                  policies and practices.
                </p>
                <p>
                  GBR Farming does not control and is not responsible for the
                  privacy practices, content or security of third-party
                  websites or services.
                </p>
                <p>
                  We recommend reviewing the privacy policy of any third-party
                  service before providing personal information to it.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>16. Children's Privacy</h3>
                <p>
                  GBR Farming's website and business services are primarily
                  intended for organisations, professionals, businesses,
                  ecosystem operators and other authorised users.
                </p>
                <p>
                  Our services are not intended to knowingly collect personal
                  information from children except where permitted by
                  applicable law and through appropriate mechanisms.
                </p>
                <p>
                  Where applicable law requires parental or guardian consent or
                  additional safeguards for processing children's personal
                  information, GBR Farming will apply such requirements to the
                  extent applicable to the relevant service and processing
                  activity.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>17. Marketing Communications</h3>
                <p>
                  Where permitted by applicable law, GBR Farming may send
                  communications relating to our services, ecosystem
                  initiatives, products, events and business activities.
                </p>
                <p>
                  You may unsubscribe from promotional communications using the
                  unsubscribe mechanism included in the relevant communication
                  or by contacting us.
                </p>
                <p>
                  Unsubscribing from marketing communications does not
                  necessarily stop essential communications relating to your
                  account, contractual relationship, security, transactions,
                  legal obligations or services.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>18. Security Incidents and Data Breaches</h3>
                <p>
                  GBR Farming maintains processes intended to identify, assess,
                  manage and respond to security incidents involving personal
                  information.
                </p>
                <p>
                  Where a security incident or personal data breach occurs, GBR
                  Farming will take reasonable steps to:
                </p>
                <ul>
                  <li>investigate the incident;</li>
                  <li>contain and mitigate its impact;</li>
                  <li>restore affected services where appropriate;</li>
                  <li>assess the information involved;</li>
                  <li>implement corrective measures; and</li>
                  <li>
                    provide notifications to affected individuals, customers,
                    authorities or other parties where required by applicable
                    law or contractual obligations.
                  </li>
                </ul>
              </div>

              <div className="terms-subcontainer">
                <h3>19. Changes to This Privacy Policy</h3>
                <p>
                  GBR Farming may update this Privacy Policy from time to time
                  to reflect:
                </p>
                <ul>
                  <li>changes in our services;</li>
                  <li>changes in technology;</li>
                  <li>changes in our business operations;</li>
                  <li>
                    changes in applicable law or regulatory requirements; or
                  </li>
                  <li>changes in our privacy practices.</li>
                </ul>
                <p>
                  When we update this Privacy Policy, we will update the Last
                  Updated date displayed at the beginning of the policy.
                </p>
                <p>
                  Where required by applicable law, we will provide additional
                  notice or obtain consent for material changes.
                </p>
                <p>
                  Your continued use of the applicable website or services
                  after an updated Privacy Policy becomes effective will be
                  subject to the updated policy, to the extent permitted by
                  applicable law.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>20. Contact Us</h3>
                <p>
                  If you have questions, requests or concerns regarding this
                  Privacy Policy or the processing of your personal
                  information, you may contact GBR Farming at:
                </p>
                <p>
                  <b>GBR Farming Private Limited</b>
                  <br />
                  CIN: U74999KA2021PTC143080
                </p>
                <p>
                  <b>Registered Office:</b>
                  <br />
                  49054, SDA,
                  <br />
                  Panthur Main Road, Balagere,
                  <br />
                  Bangalore – 560087, Karnataka, India.
                </p>
                <p>
                  <b>General Contact:</b>
                  <br />
                  <a href="mailto:admin@gbrapp.com">admin@gbrapp.com</a>
                </p>
                <p>
                  <b>Privacy, Legal Notices &amp; Grievance Contact:</b>
                  <br />
                  <a href="mailto:admin@gbrapp.com">admin@gbrapp.com</a>
                </p>
                <p>
                  <b>Legal / Grievance Contact:</b>
                  <br />
                  Keval Singh, Director
                </p>
                <p>
                  <b>Website:</b>
                  <br />
                  gbrapp.com
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>21. Grievance Redressal</h3>
                <p>
                  If you have a grievance concerning the processing of your
                  personal information or a privacy-related matter, you may
                  submit your grievance to:
                </p>
                <p>
                  <b>Grievance Contact:</b> Avikesh, Director
                  <br />
                  <b>Email:</b>{" "}
                  <a href="mailto:admin@gbrapp.com">admin@gbrapp.com</a>
                  <br />
                  <b>Address:</b>
                  <br />
                  GBR Farming Private Limited
                  <br />
                  49054, SDA,
                  <br />
                  Panthur Main Road, Balagere,
                  <br />
                  Bangalore – 560087, Karnataka, India.
                </p>
                <p>
                  Please include sufficient information in your grievance to
                  enable GBR Farming to identify the relevant account, service,
                  transaction or processing activity and investigate the
                  matter.
                </p>
                <p>
                  GBR Farming will review and address grievances in accordance
                  with applicable law, its internal procedures and any
                  contractual obligations applicable to the relevant service.
                </p>
                <p>
                  Where a privacy request relates to information processed by
                  GBR Farming on behalf of an ENO or customer, GBR Farming may
                  direct the request to, or coordinate with, the relevant ENO
                  or customer where appropriate.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>22. Governing Law</h3>
                <p>
                  This Privacy Policy shall be governed by and interpreted in
                  accordance with the laws of India, subject to applicable
                  mandatory data-protection and privacy laws that may apply to
                  the relevant individual or processing activity.
                </p>
                <p>
                  Nothing in this Privacy Policy is intended to limit any
                  mandatory rights or protections available to an individual
                  under applicable law.
                </p>
              </div>

              <div className="terms-subcontainer">
                <h3>23. Relationship with Other Legal Documents</h3>
                <p>
                  This Privacy Policy forms part of GBR Farming's broader legal
                  framework.
                </p>
                <p>
                  Depending on the service or relationship, other terms may
                  apply, including:
                </p>
                <ul>
                  <li>GBR Farming Terms &amp; Conditions;</li>
                  <li>service-specific terms;</li>
                  <li>customer or ENO agreements;</li>
                  <li>data-processing or data-protection terms;</li>
                  <li>acceptable-use requirements;</li>
                  <li>commercial agreements; and</li>
                  <li>
                    other notices or policies applicable to specific services.
                  </li>
                </ul>
                <p>
                  Where a specific agreement contains provisions governing the
                  processing of personal information, those provisions will
                  apply to the extent legally permitted and applicable to the
                  relevant relationship.
                </p>
              </div>
            </Grid>
          </Grid>
        </Container>
      </>
    );
  }
}
